import * as ResumoHttp from '../../../../services/api/https/picking/resumo-separcao.http'
import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  INITIAL_FETCH: 'Carregando resumo',
}

const INITIAL_STATE = {
  tabActiveIndex: 0,
  leftover_products: [],
  missing_products: [],
  missing_reasons: [],
  loadingMessage: LOAD_MESSAGE.NONE,
  selectedPicking: null,
  errorMessage: null,
}

export default function useResumoSeparacao() {
  const [state, setState] = useState(INITIAL_STATE)

  const localDispatch = useMemo(() => {
    return {
      // Actions
      getResumoInfo(selectedPicking) {
        ResumoHttp.getResumoSeparacaoInfo(selectedPicking.id)
          .then(resumoData => {
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              leftover_products: resumoData.leftover_products,
              missing_products: resumoData.missing_products,
              missing_reasons: resumoData.missing_reasons,
            }))
          })
          .catch(error =>
            setState(prevState => ({ ...prevState, errorMessage: errorHandler(error) })),
          )
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      // Events
      onInit(selectedPicking) {
        setState(prevState => ({
          ...prevState,
          selectedPicking: selectedPicking,
          loadingMessage: LOAD_MESSAGE.INITIAL_FETCH,
        }))
      },

      reload() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.INITIAL_FETCH,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
